/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  customButtonContainer: 'customButtonContainer_fde4ad8d',
  icon: 'icon_fde4ad8d',
  themeDarkAltColor: 'themeDarkAltColor_fde4ad8d',
  leftText: 'leftText_fde4ad8d',
  splitter: 'splitter_fde4ad8d',
  button: 'button_fde4ad8d',
  darkerBG: 'darkerBG_fde4ad8d',
};

export = styles;

loadStyles([{"rawString":".customButtonContainer_fde4ad8d{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.icon_fde4ad8d{display:inline-block;font-family:FabricMDL2Icons;font-style:normal;font-weight:400;speak:none;font-size:14px;position:relative}.themeDarkAltColor_fde4ad8d{color:"},{"theme":"themeDarkAlt","defaultValue":"#106ebe"},{"rawString":"}.leftText_fde4ad8d{margin-left:6px;font-size:14px;font-weight:400;color:"},{"theme":"neutralPrimary","defaultValue":"#333333"},{"rawString":"}.splitter_fde4ad8d{font-size:14px;font-weight:400;color:"},{"theme":"neutralTertiary","defaultValue":"#a6a6a6"},{"rawString":";background:0 0;position:relative;top:-2px;height:40px}.button_fde4ad8d.ms-Button{height:40px;min-width:28px;padding:0 5px}.button_fde4ad8d:hover{background:initial}.darkerBG_fde4ad8d{background:#d0d0d0}"}]);
/* tslint:enable */